import { CleaningScheduleTypeEnum } from '@pimm/services/lib/sms-workforce/types';

export const getScheduleColor = (scheduleType: CleaningScheduleTypeEnum): string => {
  switch (scheduleType) {
    case CleaningScheduleTypeEnum.Monthly:
      return 'purple';
    case CleaningScheduleTypeEnum.Weekly:
      return 'green';
    case CleaningScheduleTypeEnum.Daily:
    default:
      return 'blue';
  }
};
